import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import ChevronLeft from "./icons/chevron-left-icon";
import ChevronRight from "./icons/chevron-right-icon";

const TipCarousel = ({ tips = [], autoPlayInterval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const goToPreviousTip = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? tips.length - 1 : prevIndex - 1));
    setTimeout(() => setIsAnimating(false), 500);
  };

  const goToNextTip = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) => (prevIndex === tips.length - 1 ? 0 : prevIndex + 1));
    setTimeout(() => setIsAnimating(false), 500);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNextTip();
    }, autoPlayInterval);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div className='tip-carousel'>
      <button type='button' className='tip-seek-button' aria-label='Previous tip' onClick={goToPreviousTip}>
        <ChevronLeft />
      </button>
      <div className='tip-carousel-wrapper'>
        <div
          className='tip-slide'
          style={{ transform: `translateX(-${currentIndex * 100}%)`, transition: 'transform 0.5s ease-in-out' }}
        >
          {tips.map((tip) => (
            <div key={tip.key} className='tip'>
              <h2 className='tip-title'>{tip.title}</h2>
              <p className='tip-description'>{tip.description}</p>
            </div>
          ))}
        </div>
      </div>
      <button type='button' className='tip-seek-button' aria-label='Next tip' onClick={goToNextTip}>
        <ChevronRight />
      </button>
    </div>
  );
};

TipCarousel.propTypes = {
  tips: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  })),
  autoPlayInterval: PropTypes.number,
};

export default TipCarousel;
